import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'sanha',
} as IModuleProps;
